import React, { useState } from 'react';
import { TextField, Grid, Typography } from '@mui/material';
import { IUserGuiModel } from '../../../model/IUserGuiModel';
import { useTranslation } from 'react-i18next';

interface UserProfileDataFormProps {
    initialData: IUserGuiModel;
    onDataChange: (data: IUserGuiModel) => void;
}

const UserProfileDataForm: React.FC<UserProfileDataFormProps> = ({ initialData, onDataChange }) => {
    const [formData, setFormData] = useState<IUserGuiModel>(initialData);
    const { t } = useTranslation();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const updatedData = { ...formData, [name]: { value } };
        setFormData(updatedData);
        onDataChange(updatedData);
    };

    return (
        <div>
            <Typography variant="h5" gutterBottom sx={{ mb: 10 }}> 
                {t("userProfile.updateUser")}
            </Typography>
            <Grid container spacing={4}> 
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label={t("basic.firstName")}
                        name="firstName"
                        value={formData.firstName?.value || ''}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label={t("basic.lastName")}
                        name="lastName"
                        value={formData.lastName?.value || ''}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label={t("userProfile.mobileNumber")}
                        name="mobile"
                        type="text"
                        value={formData.mobile?.value || ''}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label={t("userProfile.telephoneNumber")}
                        name="phone"
                        type="text"
                        value={formData.phone?.value || ''}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={18}> 
                    <TextField
                        fullWidth
                        label={t("userProfile.title")}
                        name="title"
                        value={formData.title?.value || ''}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid item xs={18}> 
                    <TextField
                        fullWidth
                        label={t("userProfile.dateOfBirth")}
                        name="dateOfBirth"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                        value={formData.dateOfBirth?.value || ''}
                        onChange={handleChange}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default UserProfileDataForm;
